import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
// Tools
import VueSession from "vue-session";
import Swal from "sweetalert2";
import axios from "axios";
import VueAxios from "vue-axios";
import { bus } from "@/main";

// AppSub
import AppSub from "../views/AppSub/AppSub.vue";
import Dashboard from "../views/AppSub/Dashboard.vue";
import SearchHomePage from "../views/AppSub/SearchHomePage.vue";
import MainWord from "../views/AppSub/CreateEditWord/MainWord.vue";
import Satisfaction from "../views/AppSub/Satisfaction.vue";
import History from "../views/AppSub/History.vue";
import RequestWord from "../views/AppSub/RequestWord/RequestWord.vue";
import ForgetPassword from "../views/ForgetPassword.vue";
import ResetPassword from "../views/ResetPassword.vue";
import ReplyEmail from "../views/AppSub/RequestWord/ReplyEmail.vue";
// Settings
import AppBehide from "../views/AppBehide/AppBehide.vue";

import Settings from "../views/AppBehide/Settings/AppSetting.vue";
import AllSettings from "../views/AppBehide/Settings/AllSettings.vue";
import Language from "../views/AppBehide/Settings/Language.vue";
import Category from "../views/AppBehide/Settings/Category.vue";
import TypeOfWord from "../views/AppBehide/Settings/TypeOfWord.vue";
import Permission from "../views/AppBehide/Settings/Permission.vue";

Vue.use(VueRouter);
var options = {
  persist: true,
};
Vue.use(VueSession, options);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    // APP SUB
    {
      path: "/",
      name: "AppSub",
      component: AppSub,
      children: [
        {
          path: "/forget_password",
          name: "Forget Password",
          component: ForgetPassword,
        },
        {
          path: "/reset_password",
          name: "Reset Password",
          component: ResetPassword,
        },
        {
          path: "/search",
          name: "Search Home Page",
          component: SearchHomePage,
        },
        {
          path: "/dashboard/:mode",
          name: "Dashboard",
          component: Dashboard,
        },
        {
          path: "/word/:mode",
          name: "Create Word",
          component: MainWord,
        },
        // {
        //   path: "/edit",
        //   name: "Edit Word",
        //   component: MainWord,
        // },
        // {
        //   path: "/word",
        //   name: "Word Detail",
        //   component: MainWord,
        // },
        {
          path: "/satisfaction",
          name: "Satisfaction",
          component: Satisfaction,
        },
        {
          path: "/history/:mode",
          name: "History",
          component: History,
        },
        {
          path: "/requestword",
          name: "Request Word",
          component: RequestWord,
        },
        {
          path: "/reply",
          name: "Reply Email",
          component: ReplyEmail,
        },
      ],
    },

    // APP BEHIDE
    {
      path: "/",
      name: "AppBehide",
      component: AppBehide,
      children: [
        {
          path: "/setting",
          name: "setting",
          component: Settings,
          children: [
            {
              path: "/setting/",
              name: "Language",
              component: AllSettings,
            },
            {
              path: "/setting/language",
              name: "Language",
              component: Language,
            },
            {
              path: "/setting/category",
              name: "Category",
              component: Category,
            },
            {
              path: "/setting/type_of_word",
              name: "Type Of Word",
              component: TypeOfWord,
            },
            {
              path: "/setting/permission",
              name: "Permission",
              component: Permission,
            },
          ],
        },
      ],
    },
    {
      path: "*",
      name: "Other URL",
      show_navbar: false,
      redirect: "/search",
    },
  ],
});

export default router;
router.beforeEach((to, from, next) => {
  // not authentication
  if (
    !Vue.prototype.$session.get("token_roy") ||
    !Vue.prototype.$session.get("user_id_roy")
  ) {
    // protect infinity loop
    // if not authentication user can go to ( LoginPage && SearchPage ) ONLY !!
    if (
      to.path === "/login" ||
      to.path === "/search" ||
      to.path === "/forget_password" ||
      to.path === "/reset_password"
    ) {
      next();
    } else {
      Vue.prototype.$session.clear();
      next(process.env.VUE_APP_HOME);
    }
  }
  // authenticated
  else {
    // if authentication success user can go to anywhere but can't go to ( LoginPage || '/' ) again
    if (
      to.path === "/" ||
      to.path === "/login" ||
      to.path === "/forget_password" ||
      to.path === "/reset_password"
    ) {
      next(process.env.VUE_APP_HOME);
    } else {
      next();
    }
    // if remember me
    if (Vue.prototype.$session.get("remember_me") == true) {
      if (to.path === "/" || to.path === "/login") {
        next(process.env.VUE_APP_HOME);
      } else {
        next();
      }
    }
    // if not remember me || login is not normal
    else {
      // const session time 7 Hour.
      const sessionTime_DIFFERENCE = 7 * 60 * 60 * 1000;
      // old session time
      var sessionTime_OLD = Vue.prototype.$session.get("sessionTime");
      // now time
      var sessionTime_NOW = new Date();

      // now - old > diff OR not have session Timeout
      if (
        sessionTime_NOW - Date.parse(sessionTime_OLD) >
        sessionTime_DIFFERENCE
      ) {
        console.log("sessionTimeOut");
        Swal.fire(
          "Session Timeout",
          "หมดเวลา Session กรุณา Login ใหม่",
          "warning"
        ).then((result) => {
          // console.log('auto logout normal');
          let data = {
            userId: Vue.prototype.$session.get("user_id_roy"),
          };
          let header_token = {
            headers: {
              token: Vue.prototype.$session.get("token_roy")
                ? Vue.prototype.$session.get("token_roy")
                : "token_inet_dev",
            },
          };
          Vue.prototype.axios
            .post(
              process.env.VUE_APP_API + "api/v1/logout/",
              data,
              header_token
            )
            .then((response) => {
              // console.log(response.data);
              if (response.data == "success") {
                Vue.prototype.$session.clear();
                next("/login");
              }
            })
            .catch((err) => {
              console.log("api logout err!!");
            });
        });
      } else {
        Vue.prototype.$session.set("sessionTime", sessionTime_NOW);
        if (to.path === "/" || to.path === "/login") {
          next(process.env.VUE_APP_HOME);
        } else {
          next();
        }
      }
    }
  }
});

router.afterEach((to, from) => {
  // not authentication
  if (
    !Vue.prototype.$session.get("token_roy") ||
    !Vue.prototype.$session.get("user_id_roy")
  ) {
    // do nothing!
  }
  // authenticated
  else {
    // get notification counter when change path
    bus.$emit("getNotificationCounter", "GET");
  }
});
